export default "__VITE_ASSET__amX15e1k__"